"use client";
import GAnalytics from "@/components/GAnalytics";
import { Fragment } from "react";

export default function Analytics() {
  return (
    <Fragment>
      <GAnalytics id="G-98MWVCBDD7" />
      <GAnalytics id="AW-10823601447" />
    </Fragment>
  );
}
